import React from "react";
import HeaderWrapper from "./Header";
import Footer from "./Footer";
import { GlobalContext } from "../contexts/Global";
function Layout(props) {



  return (
    <>
      <main>

        <HeaderWrapper blackNav={props.blackNav} animateLogo={props.animateLogo} location={props.location} navStyle={props.navStyle} />
        <GlobalContext.Provider value={
          {
            tagList: props.tagList || [],
            blogContent: props.blogContent || {},
            navStyle: props.navStyle || `black`
          }
        }>

          {
            // removed max-w-[1920px]
            props.lineUnderNav && (
              <div aria-hidden="true" className={`absolute left-0 line-under-nav-height w-full h-[1px] z-30 width-padding nav-line  z-index-fix ${props.hideLineMobile ? `mobile:hidden` : ``} ${props.navStyle}`}>
              </div>

            )
          }


          {props.children}
        </GlobalContext.Provider>
        <Footer />
      </main>

    </>
  );
}

export default Layout;
